import React, { Component } from 'react';
import { connect } from 'react-redux';
import SuperGrid from '../../components/SuperGrid';
import {
    autoUpdateStart,
    autoUpdateStop,
    bookmarksSelector,
    canCopySelector,
    canExportHistorySelector,
    canCreateByFormSelector,
    canDeleteSelector,
    listSelector,
    progressSelector,
    totalCountSelector,
    canSearchSelector,
} from '../../ducks/gridList';
import { withRouter } from 'react-router-dom';
import Card from './card';
import { withTranslation } from 'react-i18next';
import {
    actionsSelector,
    allIdsSelector,
    clearAllIdsRequest,
    deleteEntryRequest,
    getActionsRequest,
    getAllIdsRequest,
    invokeActionRequest,
} from '../../ducks/gridActions';
import {
    editRepresentationRequest,
    getRepresentationsRequest,
    representationFromGridSelector,
    representationNameSelector,
} from '../../ducks/representations';
import {
    GRID_CARD_LINK,
    GRID_NEW_LINK,
} from '../../router/links';
import { isCustomPageSelector, startAutoUpdateConfigRequest, stopAutoUpdateConfigRequest } from '../../ducks/profile';
import ParamsFromActions from "./components/paramsFromActions";

class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmation: { open: false },
            formModal: { open: false, columns: [] },
        };
    }

    componentWillUnmount() {
        this.props.stopUpdate({ isClear: true });
        this.props.stopConfigUpdate();
    }

    confirmAction(item, t, rows, clearSelectedRows, model, invokeAction, name, message) {
        this.showConfirmation(
            message, 
            () => {
                this.closeConfirmation();
                this.invokeGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name, true);
            }
        );
    };

    invokeConfirmedGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name, isConfirmed) {
        invokeAction({
            ids: rows,
            name,
            actionName: item.name,
            isConfirmed,
            callbackSuccess: () => {
                clearSelectedRows();
            },
            callbackConfirmation: (message) => this.confirmAction(item, t, rows, clearSelectedRows, model, invokeAction, name, message)
        });
    }

    invokeGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name, isConfirmed) {
        let content = `${item.name}.modalContent`;
        model
            ? this.setState({
                  formModal: {
                      open: true,
                      columns: model.columns,
                      actionName: item.name,
                      name,
                      ids: rows,
                      onClose: () => {
                          this.setState({formModal: {open: false}})
                      },
                      backLoad: clearSelectedRows
                  }
              })
            : (
                isConfirmed
                    ? this.invokeConfirmedGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name, isConfirmed)
                    : this.showConfirmation(
                        t(content) !== content
                                ? t(content)
                                : `${t('Are you sure to complete')} "${t(item.displayName || item.name)}" ${
                                    rows.length > 1 ? `${t('for')} ` + rows.length : ''
                                }?`,
                        () => {
                            this.closeConfirmation();
                            this.invokeConfirmedGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name, isConfirmed);
                        },
                    ));
    }

    mapActions = (item, t, invokeAction, name) => ({
        ...item,
        name: `${t(item.displayName || item.name)}`,
        action: (rows, clearSelectedRows, model) => this.invokeGridAction(item, t, rows, clearSelectedRows, model, invokeAction, name),
    });

    getGroupActions = () => {
        const { t, actions, invokeAction, match } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        const actionsFromGrid = actions.filter(item => item.allowedFromGrid);

        let obj = {
            require: actionsFromGrid
                .filter((item, index) => index < 3)
                .map(item => this.mapActions(item, t, invokeAction, name)),
            other: actionsFromGrid
                .filter((item, index) => index >= 3)
                .map(item => this.mapActions(item, t, invokeAction, name)),
            order: actionsFromGrid
                .filter((item, index) => index >= 3)
                .filter(item => item.group === 'Order')
                .map(item => this.mapActions(item, t, invokeAction, name)),
            shipping: actionsFromGrid
                .filter((item, index) => index >= 3)
                .filter(item => item.group === 'Shipping')
                .map(item => this.mapActions(item, t, invokeAction, name)),
        };

        return obj;
    };

    showConfirmation = (content, onConfirm) => {
        this.setState({ confirmation: { open: true, onConfirm, content } });
    };

    closeConfirmation = () => {
        this.setState({ confirmation: { open: false } });
    };

    modalCard = () => {
        const { stopUpdate, match = {} } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        return <Card stopUpdate={stopUpdate} name={name} />;
    };

    render() {
        const {
            columns = [],
            bookmarks = [],
            autoUpdate,
            stopUpdate,
            list,
            totalCount,
            progress,
            match = {},
            t,
            isCreateBtn,
            isCopyBtn,
            isExportHistoryBtn,
            isDeleteBtn,
            isCalculateDeliveryToForwarder,
            isExportCarrierDocuments,
            isSearchField,
            deleteEntries,
            getActions,
            getAllIds,
            editRepresentation,
            representationName,
            getRepresentations,
            startConfigUpdate,
            stopConfigUpdate,
            allIds,
            clearAllIds,
        } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        const { confirmation, formModal } = this.state;

        return (
            <div className="container">
                <SuperGrid
                    key={name}
                    columns={columns}
                    bookmarks={bookmarks}
                    rows={list}
                    name={name}
                    editRepresentation={editRepresentation}
                    representationName={representationName}
                    getRepresentations={getRepresentations}
                    autoUpdateStart={autoUpdate}
                    autoUpdateStop={stopUpdate}
                    totalCount={totalCount}
                    progress={progress}
                    storageSortItem={`${name}Sort`}
                    storageFilterItem={`${name}Filters`}
                    storageRepresentationItems={`${name}Representation`}
                    getActions={getActions}
                    groupActions={this.getGroupActions}
                    getAllIds={getAllIds}
                    modalCard={this.modalCard}
                    isCreateBtn={isCreateBtn}
                    isCopyBtn={isCopyBtn}
                    isExportHistoryBtn={isExportHistoryBtn}
                    isDeleteBtn={isDeleteBtn}
                    isCalculateDeliveryToForwarder={isCalculateDeliveryToForwarder}
                    isExportCarrierDocuments={isExportCarrierDocuments}
                    isSearchField={isSearchField}
                    deleteEntries={deleteEntries}
                    confirmation={confirmation}
                    closeConfirmation={this.closeConfirmation}
                    newLink={isCreateBtn ? GRID_NEW_LINK : null}
                    cardLink={GRID_CARD_LINK}
                    startConfigUpdate={startConfigUpdate}
                    stopConfigUpdate={stopConfigUpdate}
                    allIds={allIds}
                    clearAllIds={clearAllIds}
                />
                <ParamsFromActions formModal={formModal} />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        autoUpdate: params => {
            dispatch(autoUpdateStart(params));
        },
        stopUpdate: params => {
            dispatch(autoUpdateStop(params));
        },
        getActions: params => {
            dispatch(getActionsRequest(params));
        },
        invokeAction: params => {
            dispatch(invokeActionRequest(params));
        },
        getAllIds: params => {
            dispatch(getAllIdsRequest(params));
        },
        editRepresentation: params => {
            dispatch(editRepresentationRequest(params));
        },
        getRepresentations: params => {
            dispatch(getRepresentationsRequest(params));
        },
        startConfigUpdate: () => {
            dispatch(startAutoUpdateConfigRequest());
        },
        stopConfigUpdate: () => {
            dispatch(stopAutoUpdateConfigRequest());
        },
        clearAllIds: params => {
            dispatch(clearAllIdsRequest(params));
        },
        deleteEntries: params => {
            dispatch(deleteEntryRequest(params));
        },
    };
};

const mapStateToProps = (state, ownProps) => {
    const { match = {} } = ownProps;
    const { params = {} } = match;
    const { name = '' } = params;

    const pageState = isCustomPageSelector(state);

    return {
        columns: representationFromGridSelector(state, name),
        bookmarks: bookmarksSelector(state, name),
        list: listSelector(state),
        totalCount: totalCountSelector(state),
        progress: progressSelector(state),
        isCreateBtn: canCreateByFormSelector(state, name),
        isCopyBtn: canCopySelector(state, name),
        isExportHistoryBtn: canExportHistorySelector(state, name),
        isDeleteBtn: canDeleteSelector(state, name),
        isCalculateDeliveryToForwarder: pageState && pageState.calculateDeliveryToForwarder,
        isExportCarrierDocuments: pageState && pageState.shippingsExportCarrierDocuments,
        isSearchField: canSearchSelector(state, name),
        actions: actionsSelector(state),
        representationName: representationNameSelector(state, name),
        allIds: allIdsSelector(state),
    };
};

export default withTranslation()(
    withRouter(
        connect(
            mapStateToProps,
            mapDispatchToProps,
        )(List),
    ),
);
